import React from 'react';
import { Helmet } from 'react-helmet-async';
import { appThemeConfig } from 'utils/themeConfig';

export type TitleProps = {
  name: string | number;
};

export type ScritpProps = {
  src: string;
};

export const Title = ({ name }: TitleProps): JSX.Element => {
  return (
    <Helmet>
      <title>
        {name ? name + ' | ' : ''}
        {appThemeConfig?.meta?.title || 'NAD'}
      </title>
    </Helmet>
  );
};

export const Favicon = (): JSX.Element => {
  return (
    <Helmet>
      <link rel='icon' href={appThemeConfig?.meta?.favicon || '/favicon.ico'} />
      <link
        rel='apple-touch-icon'
        href={appThemeConfig?.meta?.appleFavicon || '/logo192.png'}
      />
    </Helmet>
  );
};

export const Script = ({ src }: ScritpProps): JSX.Element => {
  return (
    <Helmet>
      <script src={src} />
    </Helmet>
  );
};
